import React, { createContext, useContext, useEffect, useState } from 'react';
import commonApi from '../utils/api';
import { useNavigate } from 'react-router-dom';
import { CommonContext } from './CommonContext';
import { format } from 'date-fns';
import moment from 'moment';
import { Cancel, CheckCircle, Pending, WarningOutlined } from '@mui/icons-material';
import JSZip from 'jszip';

export const IVRContext = createContext();

const initialFilters = {
    searchBy: 'awb_no',
    searchValue: '',
    merchant_id: [],
    from_mobile: '',
    to_mobile: '',
    dateRange: {
        startDate: moment().subtract(1, 'month').toDate(),
        endDate: moment().add(0, 'month').toDate(),
    },
    status_id: '',
};
const tabOptions = [
    { label: "IVR Due", value: 1 },
    { label: "IVR Paid", value: 2 },
    { label: "Paid AWB Wise IVR", value: 3 },
];
const statusConfig = {
    1: { color: "success", icon: <CheckCircle fontSize="small" /> },
    2: { color: "error", icon: <Cancel fontSize="small" /> },
    3: { color: "warning", icon: <WarningOutlined fontSize="small" /> },
    4: { color: "warning", icon: <WarningOutlined fontSize="small" /> },
    5: { color: "error", icon: <Cancel fontSize="small" /> },
    6: { color: "warning", icon: <WarningOutlined fontSize="small" /> },
    7: { color: "warning", icon: <WarningOutlined fontSize="small" /> },
};
const defaultStatus = { color: "secondary", icon: <Pending fontSize="small" /> };

const options = [
    { id: 1, label: "RECEIVED", subOptions: [{ id: 11, label: "ON CALL" }, { id: 12, label: "MAIL" }] },
    { id: 2, label: "NOT RECEIVED", subOptions: [] },
    { id: 3, label: "LANGUAGE ISSUE", subOptions: [] },
    { id: 4, label: "CALL ME LATER", subOptions: [{ id: 41, label: "FOLLOW DATE" }] },
    { id: 5, label: "WRONG NUMBER", subOptions: [] },
    { id: 6, label: "DAMAGE/SHORT RECEIVED", subOptions: [] },
    {
        id: 7,
        label: "NOT CONTACTABLE",
        subOptions: [
            { id: 71, label: "NOT ANSWERING" },
            { id: 72, label: "INVALID NUMBER" },
            { id: 73, label: "CALL DISCONNECT BY CUSTOMER" },
            { id: 74, label: "CALL NOT CONNECT" },
            { id: 75, label: "NUMBER BUSY" },
        ],
    },
];
const getStatusLabel = (status) => {
    const foundOption = options.find((option) => option.id === status);
    return foundOption ? foundOption.label : "Unknown Status";
};
export const IVRContextProvider = ({ children }) => {
    const { user, setAlertMessage, setOpenAlert, setSeverity } = useContext(CommonContext);
    const navigate = useNavigate();

    const [filters, setFilters] = useState(initialFilters);
    const [activeTab, setActiveTab] = useState(tabOptions[0].value);
    const [addModal, setAddModal] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [selected, setSelected] = useState([]);
    const [allData, setAllData] = useState([]);
    const [allIVR, setAllIVR] = useState([]);
    const [recordingurl, setRecordingurl] = useState(null);
    const [firstLoading, setFirstLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [cancelDialog, setCancelDialog] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [details, setDetails] = useState();
    const [formDataTemp, setFormDataTemp] = useState({
        action: '',
        file: null,
    });

    const handleAddModal = () => {
        setAddModal(true);
    };

    const handleCloseModal = () => {
        setAddModal(false);
    };
    const handleToggleDrawer = () => {
        setIsOpen(true);
    };

    const handleDrawerClose = () => {
        setIsOpen(false);
        setDetails(null);
    };


    // console.log('filters', filters);
    const onLoadApi = (customFilters = filters) => {
        const payload = {
            ...customFilters,
            start_date: customFilters?.dateRange?.startDate
                ? format(new Date(customFilters.dateRange.startDate), 'yyyy-MM-dd')
                : null,
            end_date: customFilters?.dateRange?.endDate
                ? format(new Date(customFilters.dateRange.endDate), 'yyyy-MM-dd')
                : null,
        };
        if (user?.user_type !== "Merchant") {
            payload.admin_id = user?.id
        } else {
            payload.merchant_id = user?.id
        }

        delete payload.dateRange;
        setAllData([]);
        setAllIVR([]);
        setRecordingurl(null);
        setFirstLoading(false);
        commonApi.post(`/ivr/list?page=${page + 1}&per_page=${rowsPerPage}`, payload)
            .then((response) => {
                setFirstLoading(true);
                if (response?.data?.data) {
                    setAllIVR(response?.data?.data);
                    setAllData(response?.data);
                    setRecordingurl(response?.data?.recording_base_url);
                }
            })
            .catch((error) => {
                setFirstLoading(true);
                console.error('Error fetching data:', error);
            });
    };

    const onExport = (row) => {
        let payload = {}
        if (row) {
            payload = {
                ...row,
            }
        } else {
            payload = {
                ...filters,
                start_date: filters?.dateRange?.startDate
                    ? format(new Date(filters.dateRange.startDate), 'yyyy-MM-dd')
                    : null,
                end_date: filters?.dateRange?.endDate
                    ? format(new Date(filters.dateRange.endDate), 'yyyy-MM-dd')
                    : null,
            };
        }
        if (user?.user_type !== "Merchant") {
            payload.admin_id = user?.id
        } else {
            payload.merchant_id = user?.id
        }
        delete payload.dateRange;
        setIsLoading(true);
        console.log('export payload', payload);
        commonApi.post('/ivr/export', payload)
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    navigate('/download');
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
                setOpenAlert(true);
                setAlertMessage(error?.message || 'Something went wrong');
                setSeverity('error')
            });
    };
    const handleDownload = async (url, order) => {
        try {
            const response = await fetch(url, { method: 'GET' });
            if (!response.ok) throw new Error('Failed to fetch recording');
            const blob = await response.blob();
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `${order?.awb_no}_${order?.order_no}.mp3`; // Assumes MP3 format, adjust if needed
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error downloading recording:', error);
        }
    };
    const handleDownloadAll = async () => {
        const zip = new JSZip();
        const folder = zip.folder("recordings");

        for (const row of allIVR) {
            const response = await fetch(recordingurl + row.recording_url);
            if (!response.ok) throw new Error('Failed to fetch recording');
            const blob = await response.blob();
            folder.file(`${row?.order?.awb_no || 'recording'}.mp3`, blob);
        }

        zip.generateAsync({ type: "blob" }).then((content) => {
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(content);
            link.download = "all_recordings.zip";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    };

    const onCalling = (row) => {
        setIsLoading(true);
        const postReq = { order_id: row.order_id ?? '', awb_no: row?.order?.awb_no ?? '', customer_mobile: row?.to_mobile ?? '', ivr_mobile: user?.ivr_mobile ?? '' }
        commonApi.post('ivr/clickToCall', postReq)
            .then((response) => {
                setIsLoading(false);
                if (response?.data?.s === 1) {
                    setOpenAlert(true);
                    setAlertMessage(response?.data?.msg);
                    setSeverity('success');
                } else {
                    setOpenAlert(true);
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error');
                }
            })
            .catch((error) => {
                setIsLoading(false);
                setOpenAlert(true);
                setAlertMessage(error?.res?.data?.msg);
                setSeverity('error');
            });
    };

    // Fetch initial data when the context is created
    useEffect(() => {
        onLoadApi();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, rowsPerPage, activeTab]);


    const contextValue = {
        handleDownloadAll,
        onCalling,
        recordingurl,
        handleDownload,
        defaultStatus,
        statusConfig,
        details,
        setDetails,
        options,
        getStatusLabel,
        formDataTemp,
        setFormDataTemp,
        isOpen,
        handleToggleDrawer,
        handleDrawerClose,
        onExport,
        addModal,
        handleAddModal,
        handleCloseModal,
        initialFilters,
        allData,
        setAllData,
        allIVR,
        setAllIVR,
        page,
        setPage,
        rowsPerPage,
        setRowsPerPage,
        firstLoading,
        setFirstLoading,
        cancelDialog,
        setCancelDialog,
        isLoading,
        setIsLoading,
        onLoadApi,
        selected,
        setSelected,
        tabOptions,
        activeTab,
        setActiveTab,
        filters,
        setFilters,
    };
    return (
        <IVRContext.Provider value={contextValue}>
            {children}
        </IVRContext.Provider>
    );
};

